import Icon from 'veui/components/Icon'
import { IconQuestionCircle } from 'dls-icons-vue'

Icon.register('question-circle', IconQuestionCircle)
